import * as React from 'react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { loadChat } from 'modules/onboarding/lib/hubspot/chat'

import * as styles from './index.vanilla.css'

const HubspotChatWrapper = () => {
  const ref = React.useRef<HTMLDivElement>(null)
  const { email: userEmail } = useCurrentSession()

  useUnsafeEffect(() => {
    if (ref.current) {
      loadChat(ref, userEmail ?? '')
    }
  }, [ref, userEmail])

  return (
    <div
      className={styles.iframeWrapper}
      id="hubspot-chat-entrypoint-wrapper"
      ref={ref}
      style={{ height: '100%' }}
    />
  )
}

export default HubspotChatWrapper
